// extracted by mini-css-extract-plugin
module.exports = {"content":"DieIdee_content__3bM44"};